<template>
	<v-menu
		ref="menu"
		:close-on-content-click="false"
		v-model="menu"
		:nudge-right="40"
		:return-value.sync="time"
		transition="scale-transition"
		offset-y
		max-width="290px"
		min-width="290px"
	>
		<template v-slot:activator="{ on }">
			<v-text-field
				:value="time"
				:label="label"
				:clearable="clearable"
				prepend-icon="fa-clock"
				readonly
				v-on="on"
				:disabled="disabled"
				:error-count="3"
				:error-messages="errors"
				@click:clear="onInput(null)"
			></v-text-field>
		</template>
		<v-time-picker
			v-if="menu"
			:value="time"
			@input="onInput($event)"
			full-width
			:allowed-minutes="allowedStep"
			@click:minute="$refs.menu.save(time)"
		/>
	</v-menu>
</template>

<script>
export default {
	props: {
		value: String,
		label: String,
		clearable: Boolean,
		disabled: Boolean,
		step: {
			type: [Number, String],
			default: 5,
		},
		errors: {
			type: Array,
			default: () => [],
		},
	},
	mounted() {
		this.time = this.value || ''
	},
	data() {
		return {
			time: '',
			menu: false,
		}
	},
	watch: {
		value(value) {
			this.time = value
		},
	},
	methods: {
		onInput(event) {
			this.$emit('input', event)
		},

		allowedStep(m) {
			return m % this.step === 0
		},
	},
}
</script>
